<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="500px"
    :title="$l('dialog_title_print_order_checklist') || '订单核对清单打印'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <div class="print_btn_group">
      <el-button plain @click="onClickPrint('single')">
        {{ $l('btn_print_use_single_po_template') || '使用单PO模版' }}
      </el-button>
      <el-button plain @click="onClickPrint('multiple')">
        {{ $l('btn_print_use_multiple_po_template') || '使用多PO模版' }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    orderCode: { type: String, default: '' }
  },
  methods: {
    onClickPrint(model) {
      // 调用清单导出接口，确认是否有对应数据
      let parms = {
        orderCode: this.orderCode,
        exportType: model
      }
      this.loadingOpen()
      this.$api
        .orderExportCheckDataApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            // 通过数据检查，增加下载任务
            this.addExportTask(model)
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addExportTask(model) {
      const taskName = `factory-order-checklist-${model}`
      const context = { orderCode: this.orderCode }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK(taskName, context)
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('tips_export_ok') ||
                '你的导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success'
            })
            this.close()
            return
          }
          this.$message.error(
            this.$l('tips_export_no') || '你的导出任务添加到下载中心失败'
          )
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('tips_export_no') || '你的导出任务添加到下载中心失败'
          )
        })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
